import { createSelector } from 'reselect';

const selectDBADBNBIZMappings = (state: any) => state.dbaDBNBIZMappings;


export const selectDBADBNBIZMappingsCurrentItem = createSelector([selectDBADBNBIZMappings], (dbaDBNBIZMappings) => dbaDBNBIZMappings.current);

export const selectDBADBNBIZMappingsListItems = createSelector([selectDBADBNBIZMappings], (dbaDBNBIZMappings) => dbaDBNBIZMappings.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectDBADBNBIZMappingsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectDBADBNBIZMappingsQueryItems = createSelector([selectDBADBNBIZMappings], (dbaDBNBIZMappings) => dbaDBNBIZMappings.query);

export const selectDBADBNBIZMappingsCreatedItem = createSelector([selectDBADBNBIZMappings], (dbaDBNBIZMappings) => dbaDBNBIZMappings.create);

export const selectDBADBNBIZMappingsUpdatedItem = createSelector([selectDBADBNBIZMappings], (dbaDBNBIZMappings) => dbaDBNBIZMappings.update);

export const selectDBADBNBIZMappingsReadItem = createSelector([selectDBADBNBIZMappings], (dbaDBNBIZMappings) => dbaDBNBIZMappings.read);

export const selectDBADBNBIZMappingsDeletedItem = createSelector([selectDBADBNBIZMappings], (dbaDBNBIZMappings) => dbaDBNBIZMappings.delete);

export const selectDBADBNBIZMappingsSearchedItems = createSelector([selectDBADBNBIZMappings], (dbaDBNBIZMappings) => dbaDBNBIZMappings.search);

export const selectDBADBNBIZMappingsItemsCount = createSelector([selectDBADBNBIZMappings], (dbaDBNBIZMappings) => dbaDBNBIZMappings.count);

export const selectDBADBNBIZMappingsItemsFilter = createSelector([selectDBADBNBIZMappings], (dbaDBNBIZMappings) => dbaDBNBIZMappings.filter);